// eslint-disable-next-line require-jsdoc
import React from 'react';
// import PropTypes from 'prop-types';
import Button from '@ids/button';
import { currencyFormatter, sortByQuantityAsc } from '../../Util/CommonUtils';
// eslint-disable-next-line import/prefer-default-export
export const GetStartedCartPricingSection = (props) => {
  const { pageData, pricing, history } = props;
  let prodPricing = pricing.filter((y) => y.PfID === pageData.Department.PFID);

  if (pageData.Department.Sku) {
    prodPricing = prodPricing.filter((x) => x.Sku.indexOf(pageData.Department.Sku) === 0);
  }

  if (pageData.Department.MaxQuantity) {
    prodPricing = prodPricing.filter((x) => x.Quantity <= pageData.Department.MaxQuantity);
  }

  if (prodPricing.length > 0) {
    prodPricing = prodPricing.sort(sortByQuantityAsc);
  }

  const hasDiscount = prodPricing.length > 0 && prodPricing[0].DiscPrice;

  const formatQuantity = (q) => {
    switch (pageData.Department.PFID) {
      case 'CHECK-15':
        return q.split('(')[1].split(' ')[0];

      default:
        return q;
    }
  };

  const handleGetStarted = () => {
    history.push(pageData.Department.PricingInformation.Link);
  };

  return (
    <div>
      <div className="row">
        <div className={hasDiscount ? 'col-lg-4 col-sm-4 col-xs-4' : 'col-lg-6 col-sm-6 col-xs-6'}>
          <p className="p2-regular font-wgt-500">Qty</p>
        </div>
        <div className={hasDiscount ? 'col-lg-4 col-sm-4 col-xs-4' : 'col-lg-6 col-sm-6 col-xs-6'}>
          <p className="p2-regular font-wgt-500" style={hasDiscount ? { color: '#8d9096' } : {}}>
            List Price
          </p>
        </div>
        {hasDiscount && (
          <div className="col-lg-4 col-sm-4 col-xs-4">
            <p className="p2-regular font-wgt-500" style={{ color: 'rgb(44, 160, 28)' }}>
              Your Price
            </p>
          </div>
        )}
      </div>
      <hr />

      {prodPricing.map((p, key) => {
        return (
          <div className="row" key={`Qty-${key}`}>
            <div
              className={hasDiscount ? 'col-lg-4 col-sm-4 col-xs-4' : 'col-lg-6 col-sm-6 col-xs-6'}
            >
              <p className="p2-regular">{formatQuantity(p.Quantity)}</p>
            </div>
            <div
              className={hasDiscount ? 'col-lg-4 col-sm-4 col-xs-4' : 'col-lg-6 col-sm-6 col-xs-6'}
            >
              <p
                className="p2-regular"
                style={hasDiscount ? { color: '#8d9096', textDecoration: 'line-through' } : {}}
              >
                {currencyFormatter(p.ListPrice)}
              </p>
            </div>
            {hasDiscount && (
              <div className="col-lg-4 col-sm-4 col-xs-4">
                <p className="p2-regular font-wgt-500" style={{ color: 'rgb(44, 160, 28)' }}>
                  {currencyFormatter(p.DiscPrice)}
                </p>
              </div>
            )}
          </div>
        );
      })}

      <div style={{ height: '20px' }} />
      <div className="row">
        <div className="col-lg-12 col-sm-12 col-xs-12">
          <Button
            theme="intuit"
            className="margin-bottom-20 pricing-btn"
            styleOverrideReason="none"
            data-wa-link="Get Started"
            data-ui-object="button"
            data-refer-ui-access-point={`get_started| ${props.contentVariable}`}
            onClick={() => {
              handleGetStarted();
            }}
          >
            Get started
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-sm-12 col-xs-12">
          <p className="p2-regular bottom-statement">
            Orders typically ship within 48 hours. Custom orders may require up to six days. Rush
            orders available. Please call <span className="font-wgt-500">(866) 570-3842</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

GetStartedCartPricingSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  // pageData: PropTypes.object.isRequired,
};
